import React from 'react';
import { IImageRepositoryItem } from './types';
import { translate } from '../../Services/translation';
import { downloadItemsAsync } from './utils';
import clsx from 'clsx';
import LoadingSpinner from '../LoadingSpinner';
import Icon from '../Icon';

interface ImageRepositoryFloatingDownloadButtonProps {
  canDownload: boolean;
  isLoading: boolean;
  items: IImageRepositoryItem[];
  onDownloadStarted: () => void;
  onDownloadFinished: () => void;
}

const ImageRepositoryFloatingDownloadButton = ({
  canDownload,
  isLoading,
  items,
  onDownloadStarted,
  onDownloadFinished,
}: ImageRepositoryFloatingDownloadButtonProps) => {
  const onFloatingDownloadClick = async () => {
    onDownloadStarted();
    try {
      await downloadItemsAsync(items);
    } finally {
      onDownloadFinished();
    }
  };

  return (
    <button
      className={clsx(
        'fixed bottom-6 right-6 flex items-center justify-center rounded-full bg-red-400 p-4 text-white transition-opacity',
        items.length > 0 ? 'opacity-100' : 'pointer-events-none opacity-0'
      )}
      title={translate('general.download')}
      onClick={onFloatingDownloadClick}
      disabled={isLoading || !canDownload}
    >
      {!isLoading && <Icon name="download-simple" className="h-6 w-6" />}
      {isLoading && <LoadingSpinner className="h-6 w-6" />}
    </button>
  );
};

export default ImageRepositoryFloatingDownloadButton;
